import { render, staticRenderFns } from "./ShowNews2024.vue?vue&type=template&id=ae9d4010"
import script from "./ShowNews2024.vue?vue&type=script&lang=js"
export * from "./ShowNews2024.vue?vue&type=script&lang=js"
import style0 from "./ShowNews2024.vue?vue&type=style&index=0&id=ae9d4010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports